import { DAYS } from ".";
export const getCollapsedDaySets = (tables) => {
    const uniqueSortedDayIndices = tables
        .flatMap((table) => table.daysAndTimes)
        .flatMap((dat) => dat.days)
        .filter((value, index, array) => {
        return array.indexOf(value) === index;
    })
        .map((d) => DAYS.indexOf(d))
        .sort();
    const sets = [];
    for (let i = 0; i < uniqueSortedDayIndices.length; i++) {
        const dayIdx = uniqueSortedDayIndices[i];
        if (dayIdx === undefined)
            throw new Error(`Missing day index for ${i} in ${uniqueSortedDayIndices}`);
        const isUsed = sets.flat().includes(dayIdx);
        if (isUsed)
            continue;
        const isLast = i === uniqueSortedDayIndices.length - 1;
        if (isLast) {
            sets.push([dayIdx]);
            continue;
        }
        const nextDayIdx = uniqueSortedDayIndices[i + 1];
        if (nextDayIdx === undefined)
            throw new Error(`Missing next day index for ${i + 1} in ${uniqueSortedDayIndices}`);
        const hasGap = nextDayIdx - dayIdx > 1;
        if (hasGap) {
            sets.push([dayIdx, nextDayIdx]);
        }
        else {
            sets.push([dayIdx]);
        }
    }
    return sets.map((s) => s.map((dayIdx) => DAYS[dayIdx]));
};
